module.exports = __webpack_public_path__ + "img/icon_5_67.4ca96b45.png";